// export const PHONE_NUMBER = "+55 11 96415-7434";
// export const EMAIL_CONTACT = "rodrigo@moriama.com.br";
// export const ADDRESS = "Rua Exemplo, 123 - São Paulo, SP";
export const CONTACT = {
    // PHONE_NUMBER: "+55 11 99457-2495",
    PHONE_NUMBER: "+55 11 96415-7434",
    EMAIL_CONTACT: "contato@menumaster.app.br",
    ADDRESS: ""
};